import createIcon from '../../createIcon';

/**
 * @component @name Synagogue
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiA4VjIxSDEwVjE2QzEwIDE0LjkgMTAuOSAxNCAxMiAxNEMxMy4xIDE0IDE0IDE0LjkgMTQgMTZWMjFIMThWOEwxMiAzTDYgOFpNMTMuNSAxMEMxMy41IDEwLjgzIDEyLjgzIDExLjUgMTIgMTEuNUMxMS4xNyAxMS41IDEwLjUgMTAuODMgMTAuNSAxMEMxMC41IDkuMTcgMTEuMTcgOC41IDEyIDguNUMxMi44MyA4LjUgMTMuNSA5LjE3IDEzLjUgMTBaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMyA1QzEuOSA1IDEgNS45IDEgN1Y4SDVWN0M1IDUuOSA0LjEgNSAzIDVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNSA5SDFWMjFINVY5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxIDVDMTkuOSA1IDE5IDUuOSAxOSA3VjhIMjNWN0MyMyA1LjkgMjIuMSA1IDIxIDVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjMgOUgxOVYyMUgyM1Y5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Synagogue = createIcon('Synagogue', [
  [
    'path',
    {
      d: 'M6 8V21H10V16C10 14.9 10.9 14 12 14C13.1 14 14 14.9 14 16V21H18V8L12 3L6 8ZM13.5 10C13.5 10.83 12.83 11.5 12 11.5C11.17 11.5 10.5 10.83 10.5 10C10.5 9.17 11.17 8.5 12 8.5C12.83 8.5 13.5 9.17 13.5 10Z',
      key: 'bl48y3',
    },
  ],
  ['path', { d: 'M3 5C1.9 5 1 5.9 1 7V8H5V7C5 5.9 4.1 5 3 5Z', key: 'kjf46m' }],
  ['path', { d: 'M5 9H1V21H5V9Z', key: 'djww8x' }],
  ['path', { d: 'M21 5C19.9 5 19 5.9 19 7V8H23V7C23 5.9 22.1 5 21 5Z', key: '1hmyqs' }],
  ['path', { d: 'M23 9H19V21H23V9Z', key: '1cp1n1' }],
]);

export default Synagogue;
